export default "__VITE_ASSET__CQnL1IQs__"